import React from "react"
import ProductHero from "../ProductHero"
import SectionTitle from "../SectionTitle"
import LeftRightHighlights from "../LeftRightHighlights"
import ComponentBannner from "../ComponentBanner"
import ImageComponent from "../ImageComponent"

type Data = {
  component: string
}

interface Props {
  components: Data[]
}
const DynamicComponentsV2 = ({ components }: Props) => {
  return (
    <div className="flex w-full flex-col">
      {components.map((item, index) => {
        if (item?.component === "product_hero")
          return (
            <div key={index} className="flex w-full">
              <ProductHero {...item} />
            </div>
          )
        if (item?.component === "componentImage")
          return <ImageComponent {...item} key={index} />
        if (item?.component === "section_title")
          return <SectionTitle {...item} key={index} />
        if (item?.component === "left_right_highlights")
          return <LeftRightHighlights {...item} key={index} />
        if (item?.component === "lifestyle_banner")
          return <ComponentBannner {...item} key={index} />
        return null
      })}
    </div>
  )
}

export default DynamicComponentsV2
